import React, { useState, useEffect } from "react";
import Axios from "axios";
import "./../../../../assets/css/purchase/form.css";

// React DateTime
import moment from "moment";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import PoModal from "../../../components/Modal/PoModal";
import ApModal from "../../../components/Modal/ApModal";
import ItemTable from "../../../components/Content/ItemTable";
import Summary from "../../../components/Footer/Summary";
import DatePicker from "../../../components/DatePicker";
import FormAction from "../../../components/Actions/FormAction";

// Model
import { recMasterModel } from "../../../../model/Purchase/RecMasterModel";
import { recDetailModel } from "../../../../model/Purchase/RecDetailModel";

// Utils
import {
  getDataWithComp,
  getByDocId,
  getByRecId,
  getDocType,
  getTransType,
  getViewPoH,
  getViewAp,
  getViewItem,
  getAlert,
  formatCurrency,
  parseCurrency,
  getLineByDocId,
  updateStatusByNo,
  updateQty,
  deleteData,
  randomDelay,
  getSpRunNumber,
  getData,
} from "../../../../utils/SamuiUtils";

import {
  formatDateTime,
  formatThaiDateUiToDate,
  getCreateDateTime,
  setCreateDateTime,
} from "../../../../utils/DateUtils";

import { manageWhItemData } from "../../../../utils/WarehouseUtils";

function Form({ callInitialize, mode, setMode, name, maxRecNo, getReport }) {
  const [formMasterList, setFormMasterList] = useState(recMasterModel());
  const [formDetailList, setFormDetailList] = useState([]);
  const [tbDocType, setTbDocType] = useState([]);
  const [tbTransType, setTbTransType] = useState([]);
  const [poDataList, setPoDataList] = useState([]);
  const [apDataList, setApDataList] = useState([]);
  const [itemDataList, setItemDataList] = useState([]);
  const [whDataList, setWhDataList] = useState([]);

  // สำหรับ Freeze หน้าจอตอนทำรายการ
  const [isLoading, setIsLoading] = useState(false);

  // การคำนวณเงิน
  const [selectedDiscountValueType, setSelectedDiscountValueType] =
    useState("2");
  const [totalPrice, setTotalPrice] = useState(0);
  const [receiptDiscount, setReceiptDiscount] = useState(0);
  const [subFinal, setSubFinal] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [isVatChecked, setIsVatChecked] = useState(false);
  const [vatAmount, setVatAmount] = useState(0);

  // ยอดชำระล่วงหน้า และ ยอดค้างชำระ (ถ้ามี)
  const [prepaymentAmount, setPrepaymentAmount] = useState(null);
  const [outstandingAmount, setOutstandingAmount] = useState(null);

  // การแสดงสถานะใบรับสินค้า
  const [statusName, setStatusName] = useState("");
  const [statusColour, setStatusColour] = useState("");

  // การแสดงสถานะการจ่ายของใบรับสินค้า
  const [statusPaidName, setStatusPaidName] = useState("");
  const [statusPaidColour, setStatusPaidColour] = useState("");

  // ตัวแปรสำหรับเก็บจำนวนเดิมเอาไว้
  const [formDetailOldList, setFormDetailOldList] = useState([]);

  // Modal สำหรับ Confirm Dialog ของรับสินค้า PO
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  // ตัวแปรเก็บ PO
  const [poDList, setPoDList] = useState([]);
  const [docStatusPo, setDocStatusPo] = useState(null);

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      // สำหรับ Freeze หน้าจอตอนทำรายการ
      setIsLoading(true);

      const docTypeList = await getDocType(1);
      if (docTypeList && docTypeList.length > 0) {
        setTbDocType(docTypeList);
      }

      const transTypeList = await getTransType();
      if (transTypeList && transTypeList.length > 0) {
        setTbTransType(transTypeList);
      }

      const poDataList = await getViewPoH();
      if (poDataList && poDataList.length > 0) {
        const filteredList = poDataList.filter(
          (item) => item.Doc_Status_ReceiveName !== "รับสินค้าครบ"
        );
        setPoDataList(filteredList);
      }

      const apDataList = await getViewAp();
      if (apDataList && apDataList.length > 0) {
        setApDataList(apDataList);
      }

      const itemDataList = await getViewItem();
      if (itemDataList && itemDataList.length > 0) {
        setItemDataList(itemDataList);
      }

      const whDataList = await getDataWithComp(
        "Tb_Set_WH",
        `AND Flag_Vansale = 'N' AND WH_Status = 'Y' ORDER BY WH_Code ASC`
      );
      if (whDataList && whDataList.length > 0) {
        setWhDataList(whDataList);
      }

      // สำหรับ View เข้ามาเพื่อแก้ไขข้อมูล
      if (mode === "U") {
        await getModelByNo(apDataList);

        const findIdByNo = await getDataWithComp(
          "REC_H",
          `AND Rec_No = '${maxRecNo}'`
        );

        // ค้นหาไฟล์ที่เกี่ยวข้อง (ปรับแต่งใหม่)
        if (findIdByNo[0].Rec_Id) {
          const image = await getDataWithComp(
            "Upload_File_List",
            `AND DocCode_ID = 3 AND Doc_ID = ${findIdByNo[0].Rec_Id}`
          );

          if (Array.isArray(image) && image.length > 0) {
            setSelectedFiles(image);
          } else {
            setSelectedFiles([]);
          }
        } else {
          setSelectedFiles([]);
        }
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.message);
    }
  };

  const getModelByNo = async (apDataList) => {
    try {
      // ค้นหาข้อมูลเอกสารที่ตรงกับ Rec_No
      const findMaster = await getDataWithComp("REC_H", "");
      const fromDatabase = findMaster.find((rec) => rec.Rec_No === maxRecNo);

      if (!fromDatabase) {
        setIsLoading(false);
        throw new Error("ไม่พบข้อมูลเอกสาร");
      }

      // ค้นหาข้อมูลผู้ขายด้วย AP_ID
      const fromViewAp = apDataList.find(
        (ap) => ap.AP_Id === fromDatabase.AP_ID
      );

      if (!fromViewAp) {
        setIsLoading(false);
        throw new Error("ไม่พบข้อมูลผู้ขาย");
      }

      // ค้นหาข้อมูล PO ด้วย Ref_DocID
      const formPoMaster = await getByDocId("PO_H", fromDatabase.Ref_DocID, "");
      setDocStatusPo(formPoMaster[0].Doc_Status);

      // ค้นหาข้อมูล VIEW
      const findViewMaster = await getDataWithComp("API_0301_REC_H", "");
      const fromView = findViewMaster.find((data) => data.Rec_No === maxRecNo);
      setStatusName(fromView.RecStatus_Name);
      setStatusColour(fromView.RecStatus_Colour);
      setStatusPaidName(fromView.DocStatusPaid_Name);
      setStatusPaidColour(fromView.DocStatusPaid_Colour);

      // ค้นหาข้อมูลที่ตรงกับ PO_H และ AP_ID ใน apDataList
      const detailResponse = await getDataWithComp(
        "API_0202_PO_D",
        `AND Item_Status = 1 AND Doc_ID = ${fromDatabase.Ref_DocID} ORDER BY Line ASC`
      );

      // ฟังก์ชันเพื่อสร้างโมเดลใหม่สำหรับแต่ละแถวและคำนวณ itemTotal
      const createNewRow = (index, itemSelected) => {
        const itemQty = parseCurrency(itemSelected.Item_Qty) || 0;
        const itemPriceUnit = parseCurrency(itemSelected.Item_Price_Unit) || 0;
        const itemDiscount = parseCurrency(itemSelected.Item_Discount) || 0;
        const ItemDisType = String(itemSelected.Item_DisType);
        let itemTotal = itemQty * itemPriceUnit;

        if (ItemDisType === "2") {
          itemTotal -= (itemDiscount / 100) * itemTotal; // ลดตามเปอร์เซ็นต์
        } else {
          itemTotal -= itemDiscount; // ลดตามจำนวนเงิน
        }

        const detail =
          detailResponse.find(
            (item) =>
              item.Item_Id === itemSelected.Item_Id &&
              parseCurrency(item.Line, 10) === parseCurrency(itemSelected.Line, 10)
          ) || {};
        const itemQtyNow = detail.Item_Qty || 0;
        const itemRecQty = detail.Item_REC_Qty || 0;

        return {
          ...recDetailModel(index + 1),
          dtId: itemSelected.DT_Id,
          recId: itemSelected.Rec_ID,
          line: itemSelected.Line,
          itemId: itemSelected.Item_Id,
          itemCode: itemSelected.Item_Code,
          itemName: itemSelected.Item_Name,
          itemQty: formatCurrency(itemQty, true),
          itemUnit: itemSelected.Item_Unit,
          itemPriceUnit: formatCurrency(itemPriceUnit, true),
          itemDiscount: formatCurrency(itemDiscount, true),
          itemDisType: String(itemSelected.Item_DisType),
          itemTotal: parseCurrency(itemTotal),
          itemGroup: itemSelected.Item_Group,
          itemRecBalance: parseCurrency(itemQtyNow) - parseCurrency(itemRecQty),
          itemStatus: itemSelected.Item_Status,
          whId: itemSelected.WH_ID,
          zoneId: itemSelected.Zone_ID,
          ltId: itemSelected.LT_ID,
          dsSeq: itemSelected.DS_SEQ,
          itemDesc: itemSelected.Item_Desc,
        };
      };

      // ค้นหาข้อมูลของ Detail ด้วย Rec_ID
      const fromDetail = await getByRecId(
        "API_0302_REC_D",
        fromDatabase.Rec_Id,
        `AND Item_Status = 1 ORDER BY Line ASC`
      );

      // ค้นหาข้อมูลของ Detail ของ PO ด้วย Doc_ID
      const formPoList = await getByDocId(
        "PO_D",
        fromDatabase.Ref_DocID,
        `AND Item_Status = 1 ORDER BY Line ASC`
      );
      setPoDList(formPoList);

      if (fromDetail.length > 0) {
        const newFormDetails = fromDetail.map((item, index) =>
          createNewRow(formDetailList.length + index, item)
        );

        setFormDetailList(newFormDetails);
        setFormDetailOldList(newFormDetails);

        setFormMasterList({
          recId: fromDatabase.Rec_Id,
          recNo: fromDatabase.Rec_No,
          recDate: fromDatabase.Rec_Date || null,
          recDueDate: fromDatabase.Rec_DueDate || null,
          recStatus: fromDatabase.Rec_Status,
          docStatusPaid: fromDatabase.Doc_Status_Paid,
          docCode: fromDatabase.Doc_Code,
          docType: fromDatabase.Doc_Type,
          docFor: fromDatabase.Doc_For,
          refDocID: fromDatabase.Ref_DocID,
          refDoc: fromDatabase.Ref_Doc,
          refDocDate: fromDatabase.Ref_DocDate,
          compId: fromDatabase.Comp_Id,
          refProjectID: fromDatabase.Ref_ProjectID,
          refProjectNo: fromDatabase.Ref_ProjectNo,
          transportType: fromDatabase.Transport_Type,
          docRemark1: fromDatabase.Doc_Remark1,
          docRemark2: fromDatabase.Doc_Remark2,
          apID: fromDatabase.AP_ID,
          apCode: fromDatabase.AP_Code,
          actionHold: fromDatabase.Action_Hold,
          discountValue: fromDatabase.Discount_Value,
          discountValueType: fromDatabase.Discount_Value_Type,
          discountCash: fromDatabase.Discount_Cash,
          discountCashType: fromDatabase.Discount_Cash_Type,
          discountTransport: fromDatabase.Discount_Transport,
          discountTransportType: fromDatabase.Discount_Transport_Type,
          isVat: fromDatabase.IsVat,
          docSEQ: fromDatabase.Doc_SEQ,
          creditTerm: fromDatabase.CreditTerm,
          creditTerm1Day: fromDatabase.CreditTerm1Day,
          creditTerm1Remark: fromDatabase.CreditTerm1Remark,
          creditTerm2Remark: fromDatabase.CreditTerm2Remark,
          accCode: fromDatabase.ACC_Code,
          empName: fromDatabase.EmpName,
          createdDate: setCreateDateTime(fromDatabase.Created_Date || null),
          createdByName: fromDatabase.Created_By_Name,
          createdById: fromDatabase.Created_By_Id,
          updateDate: setCreateDateTime(fromDatabase.Update_Date || null),
          updateByName: fromDatabase.Update_By_Name,
          updateById: fromDatabase.Update_By_Id,
          approvedDate: setCreateDateTime(fromDatabase.Approved_Date || null),
          approvedByName: fromDatabase.Approved_By_Name,
          approvedById: fromDatabase.Approved_By_Id,
          cancelDate: setCreateDateTime(fromDatabase.Cancel_Date || null),
          cancelByName: fromDatabase.Cancel_By_Name,
          cancelById: fromDatabase.Cancel_By_Id,
          approvedMemo: fromDatabase.Approved_Memo,
          printedStatus: fromDatabase.Printed_Status,
          printedDate: setCreateDateTime(fromDatabase.Printed_Date || null),
          printedBy: fromDatabase.Printed_By,
          // แสดงรายชื่อผู้ขาย
          apName: fromViewAp.AP_Name,
          apAdd1: fromViewAp.AP_Add1,
          apAdd2: fromViewAp.AP_Add2,
          apAdd3: fromViewAp.AP_Add3,
          apProvince: fromViewAp.AP_Province,
          apZipcode: fromViewAp.AP_Zipcode,
          apTaxNo: fromViewAp.AP_TaxNo,
        });

        setIsVatChecked(fromDatabase.IsVat === 1);

        const discountValueType = parseCurrency(
          fromDatabase.Discount_Value_Type
        );
        if (!isNaN(discountValueType)) {
          setSelectedDiscountValueType(discountValueType.toString());
        }
      } else {
        setIsLoading(false);
        getAlert(
          "FAILED",
          `ไม่พบข้อมูลที่ตรงกับเลขที่เอกสาร ${fromDatabase.Rec_No} กรุณาตรวจสอบและลองอีกครั้ง`
        );
      }
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.message || error);
    }
  };

  const handleCheckboxChange = (event) => {
    const { name } = event.target;
    setSelectedDiscountValueType(
      selectedDiscountValueType === name ? null : name
    );
  };

  const handleSubmit = async (status) => {
    try {
      // สำหรับ Freeze หน้าจอตอนทำรายการ
      setIsLoading(true);
      setShowConfirmModal(false);

      // ทดสอบหน่วงเวลาก่อนบันทึก (ทดสอบป้องกันการซ้ำของ Doc_No)
      await randomDelay();

      const newMaxRec = await getSpRunNumber("REC");
      if (!newMaxRec) {
        setIsLoading(false);
        getAlert("FAILED", "ไม่สามารถสร้างเลขที่เอกสารได้");
        return;
      }

      // ตรวจสอบค่า formMasterList.apID และ formMasterList.apCode
      if (!formMasterList.apID && !formMasterList.apCode) {
        setIsLoading(false);
        getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบผู้ขาย");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า apID หรือ apCode
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        setIsLoading(false);
        getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบรายละเอียดสินค้า");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ตรวจสอบค่าภายใน formDetailList
      for (const item of formDetailList) {
        if (!item.itemPriceUnit || parseCurrency(item.itemPriceUnit) === 0) {
          setIsLoading(false);
          getAlert(
            "FAILED",
            `ไม่สามารถบันทึกได้เนื่องจากไม่พบราคาต่อหน่วยของสินค้า ${item.itemName}`
          );
          return; // หยุดการทำงานหากราคาต่อหน่วยเป็น 0 หรือไม่มีค่า
        }
        if ([1, 23, 24, 25, 26, 27, 28].includes(item.itemGroup)) {
          continue;
        } else {
          if (!item.whId) {
            setIsLoading(false);
            getAlert(
              "FAILED",
              `ไม่สามารถบันทึกได้เนื่องจากไม่พบคลังสินค้าของสินค้า ${item.itemName}`
            );
            return; // หยุดการทำงานหาก whId ไม่มีค่า
          }
        }
      }

      // ข้อมูลหลักที่จะส่งไปยัง API
      // คำนวณยอดชำระล่วงหน้าที่จะนำไปรวมเป็น Discount_Value
      let prepaymentToAdd = 0;
      try {
        if (formMasterList.refDocID) {
          const payDListForDiscount = await getData(
            "PAY_D",
            `Rec_Id = ${formMasterList.refDocID}`
          );
          if (Array.isArray(payDListForDiscount) && payDListForDiscount.length > 0) {
            const uniquePayIdsForDiscount = Array.from(
              new Set(
                payDListForDiscount
                  .map((p) => p.Pay_Id)
                  .filter((id) => id !== undefined && id !== null)
              )
            );
            for (const payId of uniquePayIdsForDiscount) {
              const payHArr = await getData("PAY_H", `Pay_Id = '${payId}'`);
              if (!Array.isArray(payHArr) || payHArr.length === 0) continue;
              const payH = payHArr[0];
              // นับเฉพาะการจ่ายล่วงหน้าที่อนุมัติ (Pay_Status=2 && Pay_Type=4)
              if (Number(payH.Pay_Status) === 2 && Number(payH.Pay_Type) === 4) {
                prepaymentToAdd += Number(parseCurrency(payH.Total_Pay_NetTotal || 0) || 0);
              }
            }
          }
        }
      } catch (err) {
        prepaymentToAdd = 0;
      }

      const formMasterData = {
        rec_no: newMaxRec,
        rec_date: formMasterList.recDate,
        rec_due_date: formMasterList.recDueDate,
        rec_status: parseCurrency("2", 10),
        doc_status_paid: parseCurrency("0", 10),
        doc_code: parseCurrency("3", 10),
        doc_type: parseCurrency(formMasterList.docType, 10),
        doc_for: formMasterList.docFor,
        ref_doc_id: formMasterList.refDocID,
        ref_doc: formMasterList.refDoc,
        ref_doc_date: formMasterList.refDocDate,
        ref_project_id: formMasterList.refProjectID,
        ref_project_no: formMasterList.refProjectNo,
        comp_id: window.localStorage.getItem("company"),
        transport_type: formMasterList.transportType,
        doc_remark1: formMasterList.docRemark1,
        doc_remark2: formMasterList.docRemark2,
        ap_id: parseCurrency(formMasterList.apID, 10),
        ap_code: formMasterList.apCode,
        action_hold: parseCurrency("0", 10),
        discount_value: parseCurrency(formMasterList.discountValue || 0.0),
        discount_value_type: parseCurrency(selectedDiscountValueType, 10),
        discount_cash: parseCurrency("0.00"),
        discount_cash_type: formMasterList.discountCashType,
        discount_transport: parseCurrency("0.00"),
        discount_transport_type: formMasterList.discountTransportType,
        is_vat: isVatChecked ? parseCurrency("1", 10) : parseCurrency("2", 10),
        doc_seq: formatDateTime(new Date()),
        credit_term: parseCurrency(formMasterList.creditTerm, 10),
        credit_term_1_day: parseCurrency("0", 10),
        credit_term_1_remark: formMasterList.creditTerm1Remark,
        credit_term_2_remark: formMasterList.creditTerm2Remark,
        acc_code: "0000",
        emp_name: formMasterList.empName,
        created_date: formatThaiDateUiToDate(formMasterList.createdDate),
        created_by_name: window.localStorage.getItem("name"),
        created_by_id: "1",
        update_date: formMasterList.updateDate,
        update_by_name: formMasterList.updateByName,
        update_by_id: formMasterList.updateById,
        approved_date: formMasterList.approvedDate,
        approved_by_name: formMasterList.approvedByName,
        approved_by_id: formMasterList.approvedById,
        cancel_date: formMasterList.cancelDate,
        cancel_by_name: formMasterList.cancelByName,
        cancel_by_id: formMasterList.cancelById,
        approved_memo: formMasterList.approvedMemo,
        printed_status: "N",
        printed_date: formMasterList.printedDate,
        printed_by: formMasterList.printedBy,
      };

      // อัพสถานะรับสินค้าที่ PO_H (updateStatusByNo = async (table, field, status, where))
      await updateStatusByNo(
        "PO_H", // table: ชื่อตาราง
        "Doc_Status_Receive", // field: ชื่อฟิลด์
        status, // status: สถานะที่ต้องการอัพเดท
        `WHERE Doc_No = '${formMasterList.refDoc
        }' AND Comp_ID = '${window.localStorage.getItem("company")}'` // where: เงื่อนไขในการอัพเดท
      );

      // For Log PO_H
      // console.log("formMasterData : ", formMasterData);

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/create-rec-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // ตรวจสอบสถานะการตอบกลับ
      if (response.data.status === "OK") {
        // กรองรายการที่มี ItemQty มากกว่า 0
        const validDetails = formDetailList.filter(
          (item) => parseCurrency(item.itemQty) !== 0
        );

        if (validDetails.length > 0) {
          const getRecIdResponse = await Axios.post(
            `${process.env.REACT_APP_API_URL}/api/get-by-rec-no`,
            {
              table: "REC_H",
              rec_no: formMasterData.rec_no,
              comp_id: window.localStorage.getItem("company"),
            },
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );

          if (getRecIdResponse && getRecIdResponse.data.length > 0) {
            const recId = parseCurrency(getRecIdResponse.data[0].Rec_Id, 10);

            // หาค่า Line สูงสุด สำหรับในกรณีถ้าปิด PO แล้ว Insert
            const getMaxLine = await getLineByDocId(
              "PO_D",
              formMasterList.refDocID
            );
            let maxLine = parseCurrency(getMaxLine[0].Line, 10) + 1;

            for (const item of validDetails) {
              // เพิ่มเงื่อนไขดักว่า ถ้าพี่แบงค์เขาใส่เป็นเลข 0 มา จะต้องไม่รับเข้า REC_D และตัด PO
              if (parseCurrency(item.itemQty) > 0) {
                let findDetailPo = await getByDocId(
                  "PO_D",
                  formMasterList.refDocID,
                  `AND Item_Status = 1  AND Item_Id = ${item.itemId} ORDER BY Line ASC`
                );

                // เลือกแถว PO_D ให้ตรงกับบรรทัด (Line) ของรายการที่รับ
                const poRow = Array.isArray(findDetailPo) && findDetailPo.length > 0
                  ? (findDetailPo.find((po) => parseCurrency(po.Line, 10) === parseCurrency(item.line, 10)) || findDetailPo[0])
                  : null;
                if (!poRow) {
                  throw new Error("ไม่พบรายการ PO_D ที่ตรงกับ Line ที่เลือก");
                }

                // true = รับครบ / false = รับไม่ครบ
                let recStatusFlag =
                  parseCurrency(poRow.Item_REC_Balance) === parseCurrency(item.itemQty);

                if (status === 3 && recStatusFlag === true) {
                  // ถ้ารับครบ
                  // Harden: Update Item_REC_Qty, Item_REC_Balance (no negative), WH_ID, DS_SEQ
                  const prevRecQty = parseCurrency(poRow.Item_REC_Qty);
                  const prevBalance = parseCurrency(poRow.Item_REC_Balance);
                  const receiveNow = parseCurrency(item.itemQty);
                  const newRecQty = prevRecQty + receiveNow;
                  const newBalance = Math.max(prevBalance - receiveNow, 0);
                  await updateQty(
                    "PO_D",
                    `Item_REC_Qty = ${newRecQty}, 
                         Item_REC_Balance = ${newBalance},
                         WH_ID = ${item.whId},
                         DS_SEQ = ${formatDateTime(new Date())}`,
                    `WHERE Doc_ID = ${formMasterList.refDocID} 
                         AND Item_Id = ${item.itemId} 
                         AND Line = ${poRow.Line}
                         AND Item_Status = 1`
                  );
                } else if (status === 2 && recStatusFlag === false) {
                  // ถ้ารับไม่ครบ ไม่ปิด PO
                  // Harden: Update Item_REC_Qty, Item_REC_Balance (no negative), WH_ID, DS_SEQ
                  const prevRecQty = parseCurrency(poRow.Item_REC_Qty);
                  const prevBalance = parseCurrency(poRow.Item_REC_Balance);
                  const receiveNow = parseCurrency(item.itemQty);
                  const newRecQty = prevRecQty + receiveNow;
                  const newBalance = Math.max(prevBalance - receiveNow, 0);
                  await updateQty(
                    "PO_D",
                    `Item_REC_Qty = ${newRecQty}, 
                         Item_REC_Balance = ${newBalance},
                         WH_ID = ${item.whId},
                         DS_SEQ = ${formatDateTime(new Date())}`,
                    `WHERE Doc_ID = ${formMasterList.refDocID} 
                         AND Item_Id = ${item.itemId} 
                         AND Line = ${poRow.Line}
                         AND Item_Status = 1`
                  );
                } else if (status === 3 && recStatusFlag === false) {
                  // ถ้ารับไม่ครบ ปิด PO
                  const prevRecQty = parseCurrency(poRow.Item_REC_Qty);
                  const prevBalance = parseCurrency(poRow.Item_REC_Balance);
                  const receiveNow = parseCurrency(item.itemQty);
                  const newRecQty = prevRecQty + receiveNow;
                  const remaining = Math.max(prevBalance - receiveNow, 0);

                  // ถ้ามีของค้าง ให้สร้างรายการปิดยอดเป็น Item_Status = 0 เท่ากับจำนวนที่ค้างจริง
                  if (remaining > 0) {
                    await Axios.post(
                      `${process.env.REACT_APP_API_URL}/api/create-po-d`,
                      {
                        doc_id: parseCurrency(poRow.Doc_ID, 10),
                        line: maxLine,
                        item_id: item.itemId,
                        item_code: item.itemCode,
                        item_name: item.itemName,
                        item_qty: remaining,
                        item_unit: item.itemUnit,
                        item_price_unit: parseCurrency(item.itemPriceUnit),
                        item_discount: parseCurrency(item.itemDiscount),
                        item_distype: item.itemDisType === "1" ? 1 : 2,
                        item_total: parseCurrency(remaining * parseCurrency(item.itemPriceUnit)),
                        item_rec_qty: parseCurrency("0.00"),
                        item_rec_balance: remaining,
                        item_status: parseCurrency("0", 10),
                        wh_id: parseCurrency(item.whId, 10),
                        zone_id: parseCurrency("1", 10),
                        lt_id: parseCurrency("1", 10),
                        ds_seq: formatDateTime(new Date()),
                        item_desc: item.itemDesc,
                      },
                      {
                        headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
                      }
                    );
                    maxLine++;
                  }

                  // อัปเดตรายการเดิม: ไม่แก้ Item_Qty เดิม ให้ตัดยอดคงเหลือเป็น 0 และเพิ่มยอดรับสะสม
                  await updateQty(
                    "PO_D",
                    `Item_Qty = ${parseCurrency(poRow.Item_Qty)},
                         Item_REC_Qty = ${newRecQty}, 
                         Item_REC_Balance = ${parseCurrency("0.00", 10)},
                         WH_ID = ${item.whId},
                         DS_SEQ = ${formatDateTime(new Date())}`,
                    `WHERE Doc_ID = ${formMasterList.refDocID} 
                         AND Item_Id = ${item.itemId} 
                         AND Line = ${poRow.Line}
                         AND Item_Status = 1`
                  );
                } else {
                  // ถ้าไม่เข้าเงื่อนไข
                  // Update Item_REC_Qty, Item_REC_Balance, WH_ID, DS_SEQ
                  if (item && parseCurrency(item.itemQty) > 0) {
                    await updateQty(
                      "PO_D",
                      `Item_REC_Qty = ${parseCurrency(poRow.Item_REC_Qty) +
                      parseCurrency(item.itemQty)
                      }, 
                         Item_REC_Balance = ${parseCurrency(poRow.Item_REC_Balance) -
                      parseCurrency(item.itemQty)
                      },
                         WH_ID = ${item.whId},
                         DS_SEQ = ${formatDateTime(new Date())}`,
                      `WHERE Doc_ID = ${formMasterList.refDocID} 
                         AND Item_Id = ${item.itemId} 
                         AND Line = ${poRow.Line}
                         AND Item_Status = 1`
                    );
                  }
                }

                // #####################################
                // WH_ITEM_Onhand => Update (Loop Item) => Search WH_ITEM_Onhand Where Item,WH,Comp
                // WH_ITEM_STC => Insert (Loop Item) => Search WH_ITEM_STC Where Item,WH,Comp ORDER BY DATE
                // #####################################
                await manageWhItemData(
                  item.itemId, // Item ไอดีของสิ่งนั้นๆ
                  item.itemCode, // Item โค้ดของสิ่งนั้นๆ
                  item.itemName, // ชื่อ Item นั้นๆ
                  item.whId, // WarehouseID ของไอเทม
                  "IN", // ประเภท เช่น IN/OUT/AI/AO/TI/TO
                  parseCurrency(item.itemQty), // ค่าจำนวนที่กรอกจากหน้าจอ
                  recId, // ไอดีเอกสาร
                  newMaxRec, // เลขเอกสาร
                  formMasterList.refDoc, // เลขเอกสารอ้างอิง
                  null // หมายเหตุ
                );

                // #####################################
                // REC_H / REC_D => Insert
                let formDetailData = {
                  rec_id: recId,
                  line: poRow.Line,
                  item_id: item.itemId,
                  item_code: item.itemCode,
                  item_name: item.itemName,
                  item_qty: parseCurrency(item.itemQty),
                  item_unit: item.itemUnit,
                  item_price_unit: parseCurrency(item.itemPriceUnit),
                  item_discount: parseCurrency(item.itemDiscount),
                  item_distype: item.itemDisType === "1" ? 1 : 2,
                  item_total: item.itemTotal,
                  item_status: item.itemStatus,
                  wh_id: parseCurrency(item.whId, 10),
                  zone_id: parseCurrency("1", 10),
                  lt_id: parseCurrency("1", 10),
                  ds_seq: formatDateTime(new Date()),
                  item_desc: item.itemDesc,
                  emp_dept: poRow && (poRow.Emp_Dept ? parseCurrency(poRow.Emp_Dept, 10) : (poRow.empDept ? parseCurrency(poRow.empDept, 10) : null)),
                };
                await Axios.post(
                  `${process.env.REACT_APP_API_URL}/api/create-rec-d`,
                  formDetailData,
                  {
                    headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
                  }
                );
              }
            }

            // #####################################
            // PO_H => Update สถานะเอกสาร / สถานะรับสินค้า
            // - ถ้ารับครบ  => สถานะเอกสาร = ปิด PO / สถานะรับสินค้า = รับสินค้าครบ ✅
            // - ถ้ารับไม่ครบ  => สถานะรับสินค้า = ค้างรับ
            // #####################################
            await updateStatusPo(status, formMasterList.refDocID);
          }
          if (selectedFiles.length > 0) {
            try {
              const filteredFiles = selectedFiles.filter((file) => {
                if (typeof file === "string") {
                  return false;
                }
                return file && typeof file === "object" && file.isPending;
              });

              if (filteredFiles.length > 0) {
                const response = await Axios.post(
                  `${process.env.REACT_APP_API_URL}/api/upload-file`,
                  {
                    comp_id: window.localStorage.getItem("company"),
                    doc_id: getRecIdResponse.data[0].Rec_Id,
                    DocCode_ID: 3,
                    upload_by: window.localStorage.getItem("name"),
                    file_status: "Y",
                    files: filteredFiles,
                    doc_no_ref: null,
                  }
                );
                if (response.data.status !== "SUCCESS") {
                  getAlert("FAILED", "อัปโหลดไฟล์ล้มเหลว กรุณาลองใหม่อีกครั้ง");
                }
              }
            } catch (error) {
              getAlert("FAILED", "เกิดข้อผิดพลาดขณะอัปโหลดไฟล์");
            }
          }
        }

        callInitialize();
        getAlert(response.data.status, response.data.message);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleUpdate = async (status) => {
    try {
      setIsLoading(true);

      // ตรวจสอบค่า formMasterList.apID และ formMasterList.apCode
      if (!formMasterList.apID && !formMasterList.apCode) {
        setIsLoading(false);
        getAlert("FAILED", "ไม่สามารถแก้ไขได้เนื่องจากไม่พบผู้ขาย");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า apID หรือ apCode
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        setIsLoading(false);
        getAlert("FAILED", "ไม่สามารถแก้ไขได้เนื่องจากไม่พบรายละเอียดสินค้า");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ตรวจสอบค่าภายใน formDetailList
      for (const item of formDetailList) {
        if (!item.itemPriceUnit || parseCurrency(item.itemPriceUnit) === 0) {
          setIsLoading(false);
          getAlert(
            "FAILED",
            `ไม่สามารถแก้ไขได้เนื่องจากไม่พบราคาต่อหน่วยของสินค้า ${item.itemName}`
          );
          return; // หยุดการทำงานหากราคาต่อหน่วยเป็น 0 หรือไม่มีค่า
        }
        if ([1, 23, 24, 25, 26, 27, 28].includes(item.itemGroup)) {
          continue;
        } else {
          if (!item.whId) {
            setIsLoading(false);
            getAlert(
              "FAILED",
              `ไม่สามารถบันทึกได้เนื่องจากไม่พบคลังสินค้าของสินค้า ${item.itemName}`
            );
            return; // หยุดการทำงานหาก whId ไม่มีค่า
          }
        }
      }

      // ข้อมูลหลักที่จะส่งไปยัง API
      // หากมีการชำระล่วงหน้า ให้นำยอดชำระล่วงหน้าไปรวมใน Discount_Value และตั้ง Discount_Value_Type = 1
      let prepaymentToAddUpdate = 0;
      try {
        if (formMasterList.refDocID) {
          const payDListForDiscountUpd = await getData(
            "PAY_D",
            `Rec_Id = ${formMasterList.refDocID}`
          );
          if (Array.isArray(payDListForDiscountUpd) && payDListForDiscountUpd.length > 0) {
            const uniquePayIdsForDiscountUpd = Array.from(
              new Set(
                payDListForDiscountUpd
                  .map((p) => p.Pay_Id)
                  .filter((id) => id !== undefined && id !== null)
              )
            );
            for (const payId of uniquePayIdsForDiscountUpd) {
              const payHArr = await getData("PAY_H", `Pay_Id = '${payId}'`);
              if (!Array.isArray(payHArr) || payHArr.length === 0) continue;
              const payH = payHArr[0];
              if (Number(payH.Pay_Status) === 2 && Number(payH.Pay_Type) === 4) {
                prepaymentToAddUpdate += Number(parseCurrency(payH.Total_Pay_NetTotal || 0) || 0);
              }
            }
          }
        }
      } catch (err) {
        prepaymentToAddUpdate = 0;
      }

      const formMasterData = {
        rec_no: formMasterList.recNo,
        rec_date: formMasterList.recDate,
        rec_due_date: formMasterList.recDueDate,
        rec_status: parseCurrency(formMasterList.recStatus, 10),
        doc_status_paid: parseCurrency(formMasterList.docStatusPaid, 10),
        doc_code: parseCurrency(formMasterList.docCode, 10),
        doc_type: parseCurrency(formMasterList.docType, 10),
        doc_for: formMasterList.docFor,
        ref_doc_id: formMasterList.refDocID,
        ref_doc: formMasterList.refDoc,
        ref_doc_date: formMasterList.refDocDate,
        comp_id: formMasterList.compId,
        ref_project_id: formMasterList.refProjectID,
        ref_project_no: formMasterList.refProjectNo,
        transport_type: formMasterList.transportType,
        doc_remark1: formMasterList.docRemark1,
        doc_remark2: formMasterList.docRemark2,
        ap_id: parseCurrency(formMasterList.apID, 10),
        ap_code: formMasterList.apCode,
        action_hold: parseCurrency(formMasterList.actionHold, 10),
        discount_value: parseCurrency(formMasterList.discountValue || 0.0),
        discount_value_type: parseCurrency(selectedDiscountValueType, 10),
        discount_cash: parseCurrency(formMasterList.discountCash),
        discount_cash_type: formMasterList.discountCashType,
        discount_transport: parseCurrency(formMasterList.discountTransport),
        discount_transport_type: formMasterList.discountTransportType,
        is_vat: isVatChecked ? parseCurrency("1", 10) : parseCurrency("2", 10),
        doc_seq: formMasterList.docSEQ,
        credit_term: parseCurrency(formMasterList.creditTerm, 10),
        credit_term_1_day: parseCurrency(formMasterList.creditTerm1Day, 10),
        credit_term_1_remark: formMasterList.creditTerm1Remark,
        credit_term_2_remark: formMasterList.creditTerm2Remark,
        acc_code: formMasterList.accCode,
        emp_name: formMasterList.empName,
        created_date: formatThaiDateUiToDate(formMasterList.createdDate),
        created_by_name: formMasterList.createdByName,
        created_by_id: formMasterList.createdById,
        update_date: formatThaiDateUiToDate(getCreateDateTime()),
        update_by_name: window.localStorage.getItem("name"),
        update_by_id: window.localStorage.getItem("emp_id"),
        approved_date: formatThaiDateUiToDate(formMasterList.approvedDate),
        approved_by_name: formMasterList.approvedByName,
        approved_by_id: formMasterList.approvedById,
        cancel_date: formatThaiDateUiToDate(formMasterList.cancelDate),
        cancel_by_name: formMasterList.cancelByName,
        cancel_by_id: formMasterList.cancelById,
        approved_memo: formMasterList.approvedMemo,
        printed_status: formMasterList.printedStatus,
        printed_date: formatThaiDateUiToDate(formMasterList.printedDate),
        printed_by: formMasterList.printedBy,
      };

      // อัพสถานะรับสินค้าที่ PO_H (updateStatusByNo = async (table, field, status, where))
      // await updateStatusByNo(
      //     'PO_H',                                         // table: ชื่อตาราง
      //     'Doc_Status_Receive',                           // field: ชื่อฟิลด์
      //     status,                                         // status: สถานะที่ต้องการอัพเดท
      //     `WHERE Doc_No = '${formMasterList.refDoc}'`     // where: เงื่อนไขในการอัพเดท
      // );

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/update-rec-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // ตรวจสอบสถานะการตอบกลับ
      if (response.data.status === "OK") {
        // กรองรายการที่มี ItemQty มากกว่า 0
        const validDetails = formDetailList.filter(
          (item) => parseCurrency(item.itemQty) !== 0
        );

        if (validDetails.length > 0) {
          const recId = parseCurrency(formMasterList.recId, 10);

          for (const item of validDetails) {
            // Find REC
            let recDetail = await getByRecId(
              "REC_D",
              formMasterList.recId,
              `AND Item_Status = 1 AND Item_Id = ${item.itemId} ORDER BY Line ASC`
            );

            // Find PO
            let poDetail = await getByDocId(
              "PO_D",
              formMasterList.refDocID,
              `AND Item_Status = 1 AND Item_Id = ${item.itemId} ORDER BY Line ASC`
            );

            // เลือกแถว PO_D ให้ตรงกับบรรทัด (Line) ของรายการที่รับ
            const poRow = Array.isArray(poDetail) && poDetail.length > 0
              ? (poDetail.find((po) => parseCurrency(po.Line, 10) === parseCurrency(item.line, 10)) || poDetail[0])
              : null;
            if (!poRow) {
              console.error("ไม่พบรายการ PO_D ที่ตรงกับ Line ที่เลือก");
              continue;
            }

            // คำนวณค่าต่าง ๆ
            if (recDetail.length > 0 && poDetail.length > 0) {
              const recItem = recDetail.find(
                (rec) => rec.Item_Id === item.itemId
              );
              // const poItem = poDetail.find((po) => po.Item_Id === item.itemId);
              // แทนที่ poItem ด้วย poRow
              if (recItem && poRow) {
                let itemQty = parseCurrency(item.itemQty); // ค่าใหม่มาจากหน้าจอ
                let itemRecQty =
                  poRow.Item_REC_Qty - recItem.Item_Qty + itemQty;
                let itemRecBalance =
                  poRow.Item_REC_Balance + recItem.Item_Qty - itemQty;

                await updateQty(
                  "PO_D",
                  `Item_REC_Qty = ${itemRecQty}, Item_REC_Balance = ${itemRecBalance}`,
                  `WHERE Doc_ID = ${formMasterList.refDocID} AND Item_Id = ${item.itemId} AND Line = ${poRow.Line} AND Item_Status = 1`
                );
              } else {
                console.error("Item_Id ไม่ตรงกันระหว่าง REC และ PO");
              }
            } else {
              console.error("ไม่พบข้อมูล REC หรือ PO สำหรับ Item_Id นี้");
            }

            let oldRecItem = recDetail.find(
              (rec) => rec.Item_Id === item.itemId
            );
            if (oldRecItem) {
              // #####################################
              // เอาออกจากคลังเดิมตามจำนวนที่ค้นหาจากใบรับนี้
              // #####################################
              await manageWhItemData(
                item.itemId,
                item.itemCode,
                item.itemName,
                oldRecItem.WH_ID,
                "OUT",
                parseCurrency(oldRecItem.Item_Qty),
                recId,
                formMasterList.recNo,
                formMasterList.refDoc,
                null
              );

              // #####################################
              // เอาคลังใหม่ตามจำนวนจากหน้าจอที่แก้ไขมา
              // #####################################
              await manageWhItemData(
                item.itemId,
                item.itemCode,
                item.itemName,
                item.whId,
                "IN",
                parseCurrency(item.itemQty),
                recId,
                formMasterList.recNo,
                formMasterList.refDoc,
                null
              );
            }

            // #####################################
            // DELETE REC_D เฉพาะรายการเดียว
            // REC_H / REC_D => Insert
            await deleteData("REC_D", `WHERE DT_Id = ${item.dtId}`);
            const formDetailData = {
              rec_id: recId,
              line: poRow.Line,
              item_id: item.itemId,
              item_code: item.itemCode,
              item_name: item.itemName,
              item_qty: parseCurrency(item.itemQty),
              item_unit: item.itemUnit,
              item_price_unit: parseCurrency(item.itemPriceUnit),
              item_discount: parseCurrency(item.itemDiscount),
              item_distype: item.itemDisType === "1" ? 1 : 2,
              item_total: item.itemTotal,
              item_status: item.itemStatus,
              wh_id: parseCurrency(item.whId, 10),
              zone_id: parseCurrency("1", 10),
              lt_id: parseCurrency("1", 10),
              ds_seq: formatDateTime(new Date()),
              item_desc: item.itemDesc,
              emp_dept: poRow && (poRow.Emp_Dept ? parseCurrency(poRow.Emp_Dept, 10) : (poRow.empDept ? parseCurrency(poRow.empDept, 10) : null)),
            };

            await Axios.post(
              `${process.env.REACT_APP_API_URL}/api/create-rec-d`,
              formDetailData,
              {
                headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
              }
            );
          }

          // #####################################
          // PO_H => Update สถานะเอกสาร / สถานะรับสินค้า
          // - ถ้ารับครบ  => สถานะเอกสาร = ปิด PO / สถานะรับสินค้า = รับสินค้าครบ
          // - ถ้ารับไม่ครบ  => สถานะรับสินค้า = ค้างรับ
          // #####################################
          await updateStatusPo(3, formMasterList.refDocID);
        }
        if (selectedFiles.length > 0) {
          try {
            const filteredFiles = selectedFiles.filter((file) => {
              if (typeof file === "string") {
                return false;
              }
              return file && typeof file === "object" && file.isPending;
            });

            if (filteredFiles.length > 0) {
              const response = await Axios.post(
                `${process.env.REACT_APP_API_URL}/api/upload-file`,
                {
                  comp_id: window.localStorage.getItem("company"),
                  doc_id: formMasterList.recId,
                  DocCode_ID: 3,
                  upload_by: window.localStorage.getItem("name"),
                  file_status: "Y",
                  files: filteredFiles,
                  doc_no_ref: null,
                }
              );

              if (response.data.status !== "SUCCESS") {
                getAlert("FAILED", "อัปโหลดไฟล์ล้มเหลว กรุณาลองใหม่อีกครั้ง");
              }
            }
          } catch (error) {
            getAlert("FAILED", "เกิดข้อผิดพลาดขณะอัปโหลดไฟล์");
          }
        }

        callInitialize();
        getAlert(response.data.status, response.data.message);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleCancel = async () => {
    try {
      setIsLoading(true);

      // ตรวจสอบค่า formMasterList.apID และ formMasterList.apCode
      if (!formMasterList.apID && !formMasterList.apCode) {
        setIsLoading(false);
        getAlert("FAILED", "ไม่สามารถแก้ไขได้เนื่องจากไม่พบผู้ขาย");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า apID หรือ apCode
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        setIsLoading(false);
        getAlert("FAILED", "ไม่สามารถแก้ไขได้เนื่องจากไม่พบรายละเอียดสินค้า");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ตรวจสอบค่าภายใน formDetailList
      for (const item of formDetailList) {
        if (!item.itemQty || parseCurrency(item.itemQty) === 0) {
          setIsLoading(false);
          getAlert(
            "FAILED",
            `ไม่สามารถแก้ไขได้เนื่องจากไม่พบจำนวนของสินค้า ${item.itemName}`
          );
          return; // หยุดการทำงานหากจำนวนของสินค้าเป็น 0 หรือไม่มีค่า
        }
        if (!item.itemPriceUnit || parseCurrency(item.itemPriceUnit) === 0) {
          setIsLoading(false);
          getAlert(
            "FAILED",
            `ไม่สามารถแก้ไขได้เนื่องจากไม่พบราคาต่อหน่วยของสินค้า ${item.itemName}`
          );
          return; // หยุดการทำงานหากราคาต่อหน่วยเป็น 0 หรือไม่มีค่า
        }
      }

      // ********** ยกเลิกใบรับสินค้า ต้องย้อน PO_D ด้วย (เดี๋ยวมาทำต่อ)
      // DELETE PO_D เฉพาะรายการที่ค้างเก็บประวัติทั้งหมด (Where DocId & Item_Status = 0)
      await deleteData(
        "PO_D",
        `WHERE Doc_ID = ${formMasterList.refDocID} AND Item_Status = 0`
      );

      const poMasterList = await getByDocId(
        "PO_H",
        formMasterList.refDocID,
        ``
      );
      const poDetailList = await getByDocId(
        "PO_D",
        poMasterList[0].Doc_Id,
        `ORDER BY Line ASC`
      );
      const prDetailList = await getByDocId(
        "PR_D",
        poMasterList[0].Ref_DocID,
        `ORDER BY Line ASC`
      );

      for (const item of formDetailList) {
        let prDetail = prDetailList.find(
          (pr) =>
            pr.Item_Id === item.itemId &&
            parseCurrency(pr.Line, 10) === parseCurrency(item.line, 10)
        );
        let poDetail = poDetailList.find(
          (po) =>
            po.Item_Id === item.itemId &&
            parseCurrency(po.Line, 10) === parseCurrency(item.line, 10)
        );
        if (!prDetail || !poDetail) {
          console.error("ไม่พบรายการ PR/PO ที่ตรงกับ Line ของสินค้า", item.itemId, item.line);
          continue;
        }

        // อัพเดท
        await updateQty(
          "PO_H",
          `Doc_Status_Receive = ${parseCurrency("1", 10)}`,
          `WHERE Doc_Id = ${formMasterList.refDocID}`
        );

        // DELETE PO_D เฉพาะรายการที่ค้างเก็บประวัติทั้งหมด (Where DocId & Item_Status = 0)
        await deleteData(
          "PO_D",
          `WHERE Doc_ID = ${formMasterList.refDocID}
                     AND Item_Status = 0`
        );

        // อัพเดทจำนวนที่คำนวณใหม่ (โดยการ Where ด้วย DT_Id)
        await updateQty(
          "PO_D",
          `Item_Qty = ${prDetail.Item_Qty}, 
                     Item_Total = ${prDetail.Item_Total}, 
                     Item_REC_Qty = ${parseCurrency("0", 10)}, 
                     Item_REC_Balance = ${prDetail.Item_Qty}`,
          `WHERE DT_Id = ${poDetail.DT_Id} AND Item_Status = 1`
        );

        // #####################################
        // WH_ITEM_Onhand => Update (Loop Item) => Search WH_ITEM_Onhand Where Item,WH,Comp
        // WH_ITEM_STC => Insert (Loop Item) => Search WH_ITEM_STC Where Item,WH,Comp ORDER BY DATE
        // #####################################
        await manageWhItemData(
          item.itemId, // Item ไอดีของสิ่งนั้นๆ
          item.itemCode, // Item โค้ดของสิ่งนั้นๆ
          item.itemName, // ชื่อ Item นั้นๆ
          item.whId, // WarehouseID ของไอเทม
          "OUT", // ประเภท เช่น IN/OUT/AI/AO/TI/TO
          parseCurrency(item.itemQty), // ค่าจำนวนที่กรอกจากหน้าจอ
          formMasterList.refDocID, // ไอดีเอกสาร
          formMasterList.recNo, // เลขเอกสาร
          "ยกเลิก ".concat(formMasterList.recNo), // เลขเอกสารอ้างอิง
          null // หมายเหตุ
        );
      }

      const formMasterData = {
        rec_no: formMasterList.recNo,
        rec_status: parseCurrency("13", 10),
        cancel_date: formatThaiDateUiToDate(getCreateDateTime()),
        cancel_by_name: window.localStorage.getItem("name"),
        cancel_by_id: window.localStorage.getItem("emp_id"),
        comp_id: window.localStorage.getItem("company"),
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/cancel-rec-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      callInitialize();
      getAlert(response.data.status, response.data.message);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const updateStatusPo = async (status, docId) => {
    try {
      // Find PO
      const poDetailList = await getByDocId(
        "PO_D",
        docId,
        `AND Item_Status = 1 ORDER BY Line ASC`
      );

      // เช็กเงื่อนไขเพิ่มว่า ถ้า PO.Item_REC_Balance = 0 ทุกรายการ ให้ UPDATE PO_H.Doc_Status เป็น "ปิด PO"
      if (
        status === 3 &&
        poDetailList.every((item) => item.Item_REC_Balance === 0)
      ) {
        // อัพสถานะของ PO_H เมื่อรับสินค้าครบ และ จำนวนคงเหลือเป็น 0 ทั้งหมด
        await updateStatusByNo(
          "PO_H", // table: ชื่อตาราง
          "Doc_Status", // field: ชื่อฟิลด์
          4, // status: สถานะที่ต้องการอัพเดท
          `WHERE Doc_Id = '${docId}'` // where: เงื่อนไขในการอัพเดท
        );

        // อัพสถานะของ PO_H.Doc_Status ทันที
        await updateStatusByNo(
          "PO_H", // table: ชื่อตาราง
          "Doc_Status_Receive", // field: ชื่อฟิลด์
          3, // status: สถานะที่ต้องการอัพเดท
          `WHERE Doc_Id = '${docId}'` // where: เงื่อนไขในการอัพเดท
        );
      } else if (poDetailList.every((item) => item.Item_REC_Balance !== 0)) {
        // ถ้ารับไม่ครบ
        // อัพสถานะของ PO_H.Doc_Status ทันที
        await updateStatusByNo(
          "PO_H", // table: ชื่อตาราง
          "Doc_Status_Receive", // field: ชื่อฟิลด์
          2, // status: สถานะที่ต้องการอัพเดท
          `WHERE Doc_Id = '${docId}'` // where: เงื่อนไขในการอัพเดท
        );
      }
    } catch (error) {
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleChangeMaster = (e) => {
    const { name, value } = e.target;
    // อัปเดตค่าใน formMasterList
    setFormMasterList((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeDateMaster = (value, name) => {
    setFormMasterList((prev) => ({
      ...prev,
      [name]: value ? value.format("YYYY-MM-DD") : null,
    }));
  };

  const handleChangeDetail = (index, field, value) => {
    // ตรวจสอบว่าค่าที่กรอกเข้ามาเป็นตัวเลขหรือตัวเลขที่มีจุดทศนิยม
    if (field !== "itemDesc" && !/^\d*\.?\d*$/.test(value)) {
      //getAlert("FAILED", "กรุณากรอกเฉพาะตัวเลขเท่านั้น");
      return;
    }

    const oldList = [...formDetailOldList];
    const poD = [...poDList];

    let poItemQty = 0;

    if (field === "itemQty" && mode === "U") {
      poItemQty = poD[index].Item_Qty;
    } else {
      poItemQty = oldList[index][field];
    }

    if (
      field === "itemQty" &&
      parseCurrency(value, 10) > parseCurrency(poItemQty, 10)
    ) {
      const updatedList = [...formDetailList];
      if (mode === "U") {
        updatedList[index][field] = poD[index].Item_REC_Qty;
      } else {
        updatedList[index][field] = updatedList[index].itemRecBalance;
      }
      setFormDetailList(updatedList);
      getAlert("FAILED", "ไม่สามารถรับสินค้าเกินกว่ายอด PO ได้");
    } else if (
      field === "itemQty" &&
      parseCurrency(value, 10) < oldList[index][field]
    ) {
      updateFormDetailList(index, field, value);
    } else if (field === "whId") {
      // ไม่ต้องทำอะไร
      const updatedList = [...formDetailList];
      updatedList[index][field] = value;
    } else {
      updateFormDetailList(index, field, value);
    }
  };

  const handleFocus = (index, field) => {
    const updatedList = [...formDetailList];
    updatedList[index][field] =
      parseCurrency(updatedList[index][field].replace(/,/g, "")) || 0;
    setFormDetailList(updatedList);
  };

  const handleBlur = (index, field, value) => {
    const numericValue = parseCurrency(value.replace(/,/g, "")) || 0;
    const formattedValue = formatCurrency(
      numericValue,
      field === "itemQty" || field === "itemPriceUnit"
    );

    const updatedList = [...formDetailList];
    updatedList[index][field] = formattedValue;
    setFormDetailList(updatedList);
  };

  const handleConfirmtModal = () => {
    let shouldShowModal = false;

    formDetailList.forEach((item) => {
      // แปลงค่าของ item.itemQty และ item.itemRecBalance เป็นตัวเลข
      const itemQty = parseCurrency(item.itemQty);
      const itemRecBalance = parseCurrency(item.itemRecBalance);

      if (itemQty !== itemRecBalance) {
        shouldShowModal = true;
      }
    });

    if (shouldShowModal) {
      if (mode === "U") {
        // ไม่ให้โหมดแก้ไข เลือกปิด PO ได้
        handleUpdate(parseCurrency("2", 10));
      } else {
        setShowConfirmModal(true);
      }
    } else {
      if (mode === "U") {
        handleUpdate(parseCurrency("3", 10));
      } else {
        handleSubmit(parseCurrency("3", 10));
      }
    }
  };

  const updateFormDetailList = (index, field, value) => {
    // แปลงค่าที่กรอกเป็นจำนวนเงิน
    const numericValue = parseCurrency(value) || 0;

    const updatedList = [...formDetailList];
    updatedList[index][field] = numericValue;

    const itemQty = parseCurrency(updatedList[index].itemQty) || 0;
    const itemPriceUnit = parseCurrency(updatedList[index].itemPriceUnit) || 0;
    const itemDiscount = parseCurrency(updatedList[index].itemDiscount) || 0;
    const itemDisType = String(updatedList[index].itemDisType);

    let itemTotal = itemQty * itemPriceUnit;

    if (itemDisType === "2") {
      itemTotal -= (itemDiscount / 100) * itemTotal; // ลดตามเปอร์เซ็นต์
    } else {
      itemTotal -= itemDiscount; // ลดตามจำนวนเงิน
    }

    updatedList[index].itemTotal = itemTotal;
    setFormDetailList(updatedList);
  };

  // SET PO
  const [showPoModal, setShowPoModal] = useState(false);
  const handlePoShow = () => setShowPoModal(true);
  const handlePoClose = () => setShowPoModal(false);
  const onRowSelectPo = async (poSelected) => {
    try {
      // สำหรับ Freeze หน้าจอตอนทำรายการ
      setIsLoading(true);

      // เคลียร์ค่าใน formMasterList และ formDetailList
      setFormMasterList({});
      setFormDetailList([]);

      // ค้นหาข้อมูลที่ตรงกับ poSelected.Doc_No ใน PR_H และ AP_ID ใน apDataList
      const [getAllPoH, fromViewAp] = await Promise.all([
        getDataWithComp("API_0201_PO_H", "ORDER BY Doc_No DESC"),
        apDataList.find((ap) => ap.AP_Id === poSelected.AP_ID),
      ]);

      const fromViewPoH = getAllPoH.find(
        (po) => po.Doc_No === poSelected.Doc_No
      );

      if (!fromViewPoH || !fromViewAp) {
        setIsLoading(false);
        throw new Error("Data not found");
      }

      // ฟังก์ชันเพื่อสร้างโมเดลใหม่สำหรับแต่ละแถวและคำนวณ itemTotal
      const createNewRow = (index, itemSelected) => {
        const itemQty = parseCurrency(itemSelected.Item_REC_Balance) || 0;
        const itemPriceUnit = parseCurrency(itemSelected.Item_Price_Unit) || 0;
        const itemDiscount = parseCurrency(itemSelected.Item_Discount) || 0;
        let itemTotal = itemQty * itemPriceUnit;
        if (itemSelected.Item_DisType === 2) {
          itemTotal -= (itemDiscount / 100) * itemTotal; // ลดตามเปอร์เซ็นต์
        } else {
          itemTotal -= itemDiscount; // ลดตามจำนวนเงิน
        }

        return {
          ...recDetailModel(index + 1),
          line: itemSelected.Line,
          itemId: itemSelected.Item_Id,
          itemCode: itemSelected.Item_Code,
          itemName: itemSelected.Item_Name,
          itemQty: formatCurrency(itemQty, true) || 0,
          itemRecBalance:
            formatCurrency(itemSelected.Item_REC_Balance, true) || 0,
          itemUnit: itemSelected.Item_Unit,
          itemPriceUnit: formatCurrency(itemPriceUnit, true),
          itemDiscount: formatCurrency(itemDiscount, true),
          itemDisType: String(itemSelected.Item_DisType),
          itemTotal,
          itemGroup: itemSelected.Item_Group,
          itemStatus: itemSelected.Item_Status,
          whId: null,
          zoneId: itemSelected.Zone_ID,
          ltId: itemSelected.LT_ID,
          dsSeq: itemSelected.DS_SEQ,
          itemDesc: itemSelected.Item_Desc,
        };
      };

      const getAllItem = await getDataWithComp(
        "API_0202_PO_D",
        "AND Item_Status = 1 ORDER BY Line ASC"
      );
      const filterItem = getAllItem.filter(
        (item) => item.Doc_No === poSelected.Doc_No
      );

      const getAllItemOld = await getDataWithComp(
        "API_0202_PO_D",
        "AND Item_Status = 1 ORDER BY Line ASC"
      );
      const filterItemOld = getAllItemOld.filter(
        (item) => item.Doc_No === poSelected.Doc_No
      );

      // Find PO_H
      const getPoH = await getByDocId("PO_H", filterItem[0].Doc_ID, ``);

      // Find PO_D
      const getPoD = await getByDocId(
        "PO_D",
        filterItem[0].Doc_ID,
        `AND Item_Status = 1 ORDER BY Line ASC`
      );
      setPoDList(getPoD);
      if (filterItem.length > 0) {
        // ฟังก์ชันเพื่อกรองและสร้างรายละเอียดใหม่
        const newFormDetails = filterItem
          .filter((item) => parseCurrency(item.Item_REC_Balance) > 0) // กรองเฉพาะรายการที่มี itemQty มากกว่า 0
          .map((item, index) =>
            createNewRow(formDetailList.length + index, item)
          );

        setFormDetailList(newFormDetails);

        const firstItem = filterItem[0];

        setFormMasterList({
          ...formMasterList,
          refDocID: fromViewPoH.Doc_ID,
          refDoc: poSelected.Doc_No,
          refDocDate: poSelected.Doc_Date,
          docDate: moment()
            .utcOffset(7, true)
            .format("YYYY-MM-DD HH:mm:ss.SSS"),
          docDueDate: moment()
            .utcOffset(7, true)
            .format("YYYY-MM-DD HH:mm:ss.SSS"),
          docRemark1: fromViewPoH.Doc_Remark1,
          docRemark2: fromViewPoH.Doc_Remark2,
          docType: fromViewPoH.Doc_Type,
          docFor: fromViewPoH.Doc_For,
          transportType: fromViewPoH.Transport_Type,
          discountValue: fromViewPoH.Discount_Value,
          discount_value_type: parseCurrency(selectedDiscountValueType),
          creditTerm: getPoH[0].CreditTerm,
          apID: fromViewPoH.AP_ID,
          apCode: firstItem.AP_Code,
          apName: firstItem.AP_Name,
          apAdd1: firstItem.AP_Add1,
          apAdd2: firstItem.AP_Add2,
          apAdd3: firstItem.AP_Add3,
          apProvince: firstItem.AP_Province,
          apZipcode: firstItem.AP_Zipcode,
          apTaxNo: firstItem.AP_TaxNo,
          createdByName: window.localStorage.getItem("name"),
          createdDate: getCreateDateTime(),
          updateDate: fromViewPoH.Update_Date,
          updateByName: fromViewPoH.Update_By_Name,
        });

        setIsVatChecked(fromViewPoH.IsVat === 1 ? true : false);

        const discountValueType = parseCurrency(
          fromViewPoH.Discount_Value_Type
        );
        if (!isNaN(discountValueType)) {
          setSelectedDiscountValueType(discountValueType.toString());
        }
      } else {
        setIsLoading(false);
        getAlert(
          "FAILED",
          `ไม่พบข้อมูลที่ตรงกับเลขที่เอกสาร ${poSelected.Doc_No} กรุณาตรวจสอบและลองอีกครั้ง`
        );
      }

      if (filterItemOld.length > 0) {
        const newFormDetailsOld = filterItemOld.map((item, index) =>
          createNewRow(formDetailList.length + index, item)
        );
        setFormDetailOldList(newFormDetailsOld);
      } else {
        setIsLoading(false);
        getAlert(
          "FAILED",
          `ไม่พบข้อมูลที่ตรงกับเลขที่เอกสาร ${poSelected.Doc_No} กรุณาตรวจสอบและลองอีกครั้ง`
        );
      }

      handlePoClose();
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.message || error);
    }
  };

  // SET AP
  const [showApModal, setShowApModal] = useState(false);
  const handleApShow = () => setShowApModal(true);
  const handleApClose = () => setShowApModal(false);
  const onRowSelectAp = (apSelected) => {
    try {
      setFormMasterList({
        ...formMasterList,
        apID: apSelected.AP_Id,
        apCode: apSelected.AP_Code,
        apName: apSelected.AP_Name,
        apAdd1: apSelected.AP_Add1,
        apAdd2: apSelected.AP_Add2,
        apAdd3: apSelected.AP_Add3,
        apProvince: apSelected.AP_Province,
        apZipcode: apSelected.AP_Zipcode,
        apTaxNo: apSelected.AP_TaxNo,
      });

      if (parseCurrency(apSelected.AP_Vat) === 1) {
        setIsVatChecked(true);
      }

      handleApClose(); // ปิด modal หลังจากเลือก
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  // SET ITEM
  const [showItemModal, setShowItemModal] = useState(false);
  const handleItemShow = () => setShowItemModal(true);
  const handleItemClose = () => setShowItemModal(false);
  const onRowSelectItem = (itemsSelected) => {
    try {
      setFormDetailList([
        ...formDetailList,
        ...itemsSelected.map((itemSelected) => {
          return {
            line: null,
            itemId: itemSelected.Item_Id,
            itemCode: itemSelected.Item_Code,
            itemName: itemSelected.Item_Name,
            itemQty: formatCurrency(0),
            itemUnit: itemSelected.Item_Unit_ST,
            itemPriceUnit: formatCurrency(itemSelected.Item_Cost || 0),
            itemDiscount: formatCurrency(0),
            itemDisType: "1",
            itemTotal: 0,
            itemStatus: itemSelected.Item_Status,
            whId: null,
            whName: itemSelected.WH_Name,
            zoneId: null,
            ltId: null,
            dsSeq: null,
            itemDesc: null,
          };
        }),
      ]);
      handleItemClose();
    } catch (error) {
      getAlert("FAILED", error);
    }
  };
  const handleRemoveRow = async (index) => {
    setFormDetailList([]);
    setTimeout(() => {
      const newList = formDetailList.filter((_, i) => i !== index);
      setFormDetailList(newList);
    }, 50);
  };
  const handleVatChange = () => {
    setIsVatChecked((prev) => !prev);
  };

  // SET WAREHOUSE
  const [showWarehouseModal, setShowWarehouseModal] = useState(false);
  const handleWarehouseShow = () => setShowWarehouseModal(true);
  const handleWarehouseClose = () => setShowWarehouseModal(false);
  const onRowSelectWh = async (whSelected) => {
    handleWarehouseClose();
    if (formDetailList && formDetailList.length > 0) {
      setFormDetailList(
        formDetailList.map((item) => ({
          ...item,
          whId: whSelected.WH_Id,
        }))
      );
    } else {
      getAlert("FAILED", "กรุณาเลือกสินค้าก่อน");
    }
  };

  // Upload File
  const [openUploadAttach, setOpenUploadAttach] = useState(false);
  const [showViewAttachModal, setShowViewAttachModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const handleRemoveImage = (index) => {
    setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
    if (selectedFiles.length === 0) {
      setOpenUploadAttach(false);
    }
  };
  function handleInputFileChange(e) {
    const files = e.target.files;
    const file = files ? files[0] : null;
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const fileData = {
          id: Date.now(),
          name: file.name,
          type: file.type,
          size: file.size,
          file: file,
          dataUrl: e.target.result,
          isPending: true,
          displayName: file.name,
        };
        setSelectedFiles((prev) => [...prev, fileData]);
      };
      reader.readAsDataURL(file);
    }
  }
  const handleBeforeUploadAttach = async () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*, .pdf, .doc, .docx, .xls, .xlsx";
    input.multiple = false;
    input.onchange = (e) => handleInputFileChange(e);
    input.click();
    setOpenUploadAttach(true);
  };

  // การคำนวณยอดรวม (totalPrice)
  useEffect(() => {
    const total = formDetailList.reduce(
      (acc, item) => acc + (parseCurrency(item.itemTotal) || 0),
      0
    );
    setTotalPrice(total);
  }, [formDetailList]);

  // การคำนวณส่วนลด (receiptDiscount)
  useEffect(() => {
    let discountValue = parseCurrency(formMasterList.discountValue || 0);
    let receiptDiscount = 0;

    if (selectedDiscountValueType === "2") {
      // เปอร์เซ็นต์
      receiptDiscount = (totalPrice / 100) * discountValue;
    } else if (selectedDiscountValueType === "1") {
      // จำนวนเงิน
      receiptDiscount = discountValue;
    }

    setReceiptDiscount(receiptDiscount);
  }, [totalPrice, formMasterList.discountValue, selectedDiscountValueType]);

  // การคำนวณยอดหลังหักส่วนลด (subFinal)
  useEffect(() => {
    const subFinal = totalPrice - receiptDiscount;
    setSubFinal(subFinal);
  }, [totalPrice, receiptDiscount]);

  // การคำนวณ VAT (vatAmount)
  useEffect(() => {
    // หากมีการชำระล่วงหน้า ให้คำนวณ VAT จากยอดก่อนหักส่วนลด (totalPrice)
    const hasPrepayment = prepaymentAmount !== null && Number(prepaymentAmount) > 0;
    let vat = 0;
    if (isVatChecked) {
      if (hasPrepayment) {
        vat = totalPrice * 0.07; // คำนวณจากยอดก่อนหักส่วนลด
      } else {
        vat = subFinal * 0.07; // คำนวณจากยอดหลังหักส่วนลดตามปกติ
      }
    }
    setVatAmount(parseCurrency(vat.toFixed(4)));
  }, [subFinal, isVatChecked, totalPrice, prepaymentAmount]);

  // การคำนวณยอดรวมทั้งสิ้น (grandTotal)
  useEffect(() => {
    // หากมีการชำระล่วงหน้า ให้เอาส่วนลดมาหักหลังจากคำนวณ VAT
    const hasPrepayment = prepaymentAmount !== null && Number(prepaymentAmount) > 0;
    let computed = 0;
    if (hasPrepayment) {
      // totalPrice + VAT - discount
      computed = totalPrice + vatAmount - receiptDiscount;
    } else {
      // (totalPrice - discount) + VAT
      computed = subFinal + vatAmount;
    }
    setGrandTotal(parseCurrency(computed));
  }, [subFinal, vatAmount, totalPrice, receiptDiscount, prepaymentAmount]);

  // ยอดชำระล่วงหน้า และ ยอดค้างชำระ (ถ้ามี)
  useEffect(() => {
    const computePrepayment = async () => {
      try {
        if (!formMasterList.refDocID) {
          setPrepaymentAmount(null);
          setOutstandingAmount(null);
          return;
        }

        const payDList = await getData("PAY_D", `Rec_Id = ${formMasterList.refDocID}`);
        if (!Array.isArray(payDList) || payDList.length === 0) {
          setPrepaymentAmount(null);
          setOutstandingAmount(null);
          return;
        }

        const uniquePayIds = Array.from(new Set(payDList.map((p) => p.Pay_Id).filter((id) => id !== undefined && id !== null)));
        if (uniquePayIds.length === 0) {
          setPrepaymentAmount(null);
          setOutstandingAmount(null);
          return;
        }

        let sumPrepay = 0;
        for (const payId of uniquePayIds) {
          const payHArr = await getData("PAY_H", `Pay_Id = '${payId}'`);
          if (!Array.isArray(payHArr) || payHArr.length === 0) continue;
          const payH = payHArr[0];
          if (Number(payH.Pay_Status) === 2 && Number(payH.Pay_Type) === 4) {
            sumPrepay += Number(parseCurrency(payH.Total_Pay_NetTotal || 0) || 0);
          }
        }

        if (sumPrepay > 0) {
          setPrepaymentAmount(sumPrepay);
          setOutstandingAmount(parseCurrency((grandTotal || 0) - sumPrepay));
        } else {
          setPrepaymentAmount(null);
          setOutstandingAmount(null);
        }
      } catch (err) {
        setPrepaymentAmount(null);
        setOutstandingAmount(null);
      }
    };

    computePrepayment();
  }, [formMasterList.refDocID, grandTotal]);

  return (
    <>
      <Breadcrumbs
        page={maxRecNo}
        isShowStatus={mode === "U"}
        statusName={statusName}
        statusColour={statusColour}
        otherStatusName={statusPaidName}
        otherStatusColour={statusPaidColour}
        items={[
          { name: "จัดซื้อสินค้า", url: "/purchase" },
          { name: name, url: "/product-receipt" },
          { name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name, url: "#" },
        ]}
        onHandleClick={() => getReport("rec", formMasterList.recNo)}
        mode={mode}
        openUploadAttach={openUploadAttach}
        setOpenUploadAttach={setOpenUploadAttach}
        showViewAttachModal={showViewAttachModal}
        setShowViewAttachModal={setShowViewAttachModal}
        selectedFiles={selectedFiles}
        setSelectedFiles={setSelectedFiles}
        handleRemoveImage={handleRemoveImage}
        handleInputFileChange={handleInputFileChange}
        handleBeforeUploadAttach={handleBeforeUploadAttach}
      />

      {/* Loading Spinner */}
      {isLoading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex justify-content-center align-items-center"
          style={{ zIndex: 9999 }}
        >
          <div className="spinner-border text-light" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      <div
        className="hidden-scrollbar"
        style={{ maxHeight: "auto", overflowY: "auto" }}
      >
        <div className="row mt-1">
          <div className="col-3">
            <DatePicker
              label="วันที่เอกสาร"
              name="recDate"
              value={formMasterList.recDate}
              onChange={(date) => handleChangeDateMaster(date, "recDate")}
              disabled={mode === "U"}
            />
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>ผู้ขาย</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="apCode"
                  value={
                    (formMasterList.apCode || "") +
                    " " +
                    (formMasterList.apName || "")
                  }
                  onChange={handleChangeMaster}
                  disabled={true}
                />
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleApShow}
                  hidden={true}
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>
            </div>
            <ApModal
              showApModal={showApModal}
              handleApClose={handleApClose}
              apDataList={apDataList}
              onRowSelectAp={onRowSelectAp}
            />
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>วันที่สร้างเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="createdDate"
                value={formMasterList.createdDate}
                // onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>อ้างอิงเอกสาร</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="refDoc"
                  value={formMasterList.refDoc || ""}
                  onChange={handleChangeMaster}
                  disabled={true}
                />
                <button
                  className="btn btn-outline-secondary"
                  onClick={handlePoShow}
                  disabled={mode === "U" ? true : false}
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>
              <PoModal
                showPoModal={showPoModal}
                handlePoClose={handlePoClose}
                poDataList={poDataList}
                onRowSelectPo={onRowSelectPo}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>ที่อยู่</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="apAdd1"
                value={formMasterList.apAdd1 || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>ผู้สร้างเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="createdByName"
                value={formMasterList.createdByName || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <DatePicker
              label="วันที่เอกสารอ้างอิง"
              name="refDocDate"
              value={formMasterList.refDocDate}
              onChange={(date) => handleChangeDateMaster(date, "refDocDate")}
              disabled={true}
            />
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label></label>
              <input
                type="text"
                className="form-control input-spacing"
                value={
                  (formMasterList.apAdd2 || "") +
                  " " +
                  (formMasterList.apAdd3 || "")
                }
                disabled={true}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>วันที่แก้ไขล่าสุด</label>
              <input
                // type="date"
                type="text"
                className="form-control input-spacing"
                name="updateDate"
                value={formMasterList.updateDate || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>ประเภทเอกสาร</label>
              <select
                className="form-select form-control input-spacing"
                name="docType"
                value={formMasterList.docType}
                onChange={handleChangeMaster}
                disabled={true}
              >
                {tbDocType.map((docType) => (
                  <option key={docType.DocType_Id} value={docType.DocType_Id}>
                    {docType.DocType_Name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label></label>
              <input
                type="text"
                className="form-control input-spacing"
                value={
                  (formMasterList.apProvince || "") +
                  " " +
                  (formMasterList.apZipcode || "")
                }
                disabled={true}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>ผู้แก้ไขเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="updateByName"
                value={formMasterList.updateByName || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>วัตถุประสงค์</label>
              <select
                name="docFor"
                value={formMasterList.docFor}
                onChange={handleChangeMaster}
                disabled={true}
                className="form-select form-control input-spacing"
              >
                <option value="1">ซื้อมาเพื่อใช้</option>
                <option value="2">ซื้อมาเพื่อขาย</option>
              </select>
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>เลขที่ภาษี</label>
              <input
                type="text"
                className="form-control input-spacing"
                value={formMasterList.apTaxNo || ""}
                disabled={true}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            {/* <div className="d-flex align-items-center">
                        <label>วันที่อนุมัติ</label>
                        <input
                            type="text"
                            className="form-control input-spacing"
                            name="approvedDate"
                            value={formMasterList.approvedDate || ''}
                            onChange={handleChangeMaster}
                            disabled={true} />
                    </div> */}
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <DatePicker
              label="วันที่รับ"
              name="recDueDate"
              value={formMasterList.recDueDate}
              onChange={(date) => handleChangeDateMaster(date, "recDueDate")}
              disabled={false}
            />
          </div>
          <div className="col-6" />
          <div className="col-3 text-right">
            {/* <div className="d-flex align-items-center">
                        <label>ผู้อนุมัติเอกสาร</label>
                        <input
                            type="text"
                            className="form-control input-spacing"
                            name="approvedByName"
                            value={formMasterList.approvedByName || ''}
                            onChange={handleChangeMaster}
                            disabled={true} />
                    </div> */}
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>วิธีจัดส่ง</label>
              <select
                name="transportType"
                value={formMasterList.transportType}
                onChange={handleChangeMaster}
                disabled={false}
                className="form-select form-control input-spacing"
              >
                {tbTransType.map((transType) => (
                  <option
                    key={transType.Trans_TypeID}
                    value={transType.Trans_TypeID}
                  >
                    {transType.Trans_TypeName}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-6" />
          <div className="col-3 text-right">
            {/* <div className="d-flex align-items-center">
                        <label>หมายเหตุอนุมัติ</label>
                        <input
                            type="text"
                            className="form-control input-spacing"
                            name="approvedMemo"
                            value={formMasterList.approvedMemo || ''}
                            onChange={handleChangeMaster}
                            disabled={true} />
                    </div> */}
          </div>
        </div>
        <hr />
        <div className="row mt-2">
          <div className="col-6">
            <div className="d-flex align-items-center">
              <label>รายละเอียดเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="docRemark1"
                value={formMasterList.docRemark1 || ""}
                onChange={handleChangeMaster}
                maxLength={100}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="d-flex align-items-center">
              <label>หมายเหตุธุรการ</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="docRemark2"
                value={formMasterList.docRemark2 || ""}
                onChange={handleChangeMaster}
                maxLength={500}
              />
            </div>
          </div>
        </div>
        <div className="row mt-2">
          <ItemTable
            formDetailList={formDetailList}
            handleChangeDetail={handleChangeDetail}
            handleRemoveRow={handleRemoveRow}
            formatCurrency={formatCurrency}
            showItemModal={showItemModal}
            handleItemClose={handleItemClose}
            itemDataList={itemDataList}
            onRowSelectItem={onRowSelectItem}
            handleItemShow={handleItemShow}
            whDataList={whDataList}
            showWarehouseModal={showWarehouseModal}
            handleWarehouseClose={handleWarehouseClose}
            handleWarehouseShow={handleWarehouseShow}
            onRowSelectWh={onRowSelectWh}
            handleFocus={handleFocus}
            handleBlur={handleBlur}
            disabledRec={
              formMasterList.recStatus === 13 || (prepaymentAmount !== null && Number(prepaymentAmount) > 0)
            }
            disabled={true}
            mode={mode}
          />
          <div
            className={`modal ${showConfirmModal ? "show" : ""}`}
            style={{ display: showConfirmModal ? "block" : "none" }}
            tabIndex="-1"
            role="dialog"
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">ยืนยันการปิดงาน</h5>
                  <button
                    type="button"
                    className="close"
                    onClick={() => setShowConfirmModal(false)}
                  >
                    <span>&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  ต้องการปิดงานใบสั่งซื้อ (PO) หรือไม่?
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-lg w-25 shadow text-white"
                    style={{ backgroundColor: "#EF6C00", fontSize: "16px" }}
                    onClick={() =>
                      mode === "U"
                        ? handleUpdate(parseCurrency("2", 10))
                        : handleSubmit(parseCurrency("2", 10))
                    }
                  >
                    ค้างรับ
                  </button>
                  <button
                    type="button"
                    className="btn btn-lg w-30 shadow text-white"
                    style={{ backgroundColor: "red", fontSize: "16px" }}
                    onClick={() =>
                      mode === "U"
                        ? handleUpdate(parseCurrency("3", 10))
                        : handleSubmit(parseCurrency("3", 10))
                    }
                  >
                    ปิดงานใบ PO
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Overlay */}
          {showConfirmModal && <div className="modal-backdrop fade show"></div>}

          <Summary
            formMasterList={formMasterList}
            handleChangeMaster={handleChangeMaster}
            selectedDiscountValueType={selectedDiscountValueType}
            handleCheckboxChange={handleCheckboxChange}
            receiptDiscount={receiptDiscount}
            formatCurrency={formatCurrency}
            totalPrice={totalPrice}
            subFinal={subFinal}
            isVatChecked={isVatChecked}
            handleVatChange={handleVatChange}
            vatAmount={vatAmount}
            grandTotal={grandTotal}
            disabled={true}
            prepaymentAmount={prepaymentAmount}
            outstandingAmount={outstandingAmount}
          />
        </div>
      </div>

      <br />
      <FormAction
        onSubmit={handleConfirmtModal}
        onUpdate={handleConfirmtModal}
        onCancel={handleCancel}
        mode={mode}
        setMode={setMode}
        disabled={
          docStatusPo === 4 || formMasterList.recStatus !== 2 ? true : false
        }
        footer={true}
      />
    </>
  );
}

export default Form;
